import { text } from '#contract'
import type { LocalizedText, SaveSlotView } from '#contract'
import { dayText } from '../../i18n/dates.ts'
import { formatOsTime } from '../../os/clock.ts'

export type SavedSlot = Extract<SaveSlotView, { state: 'ok' }>

/** The slot Continue loads: the newest save that reads. */
export function newestSave(slots: readonly SaveSlotView[]): SavedSlot | null {
  let newest: SavedSlot | null = null
  for (const slot of slots) {
    if (slot.state === 'ok' && (!newest || slot.savedAt > newest.savedAt)) newest = slot
  }
  return newest
}

/** When in the game it was saved: "Thu · Week 2 · 09:00"; null in a level without a sky. */
export function savedWhen(locale: string, slot: SavedSlot): LocalizedText | null {
  if (slot.day === null || slot.minutes === null) return null
  const time = formatOsTime(Math.floor(slot.minutes))
  return text('saves.when', { day: dayText(locale, slot.day), time })
}
